module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-500-323.1773468.woff2";